export default __webpack_public_path__ + "static/media/Group_841.8809d98b.svg";